// The mock API's test clock (Test tools panel): the date and hour (IST) and buttons that move time on, so a
// campaign runs hour by hour. Whether the sending window is open shows in the top bar (WindowBadge).
import type { Clock } from '@/api/schemas'

interface DemoClockProps {
  clock: Clock
  busy: boolean
  onAdvance: (hours: number) => void
  onNextDayTen: () => void
}

export function DemoClock({ clock, busy, onAdvance, onNextDayTen }: DemoClockProps) {
  const hour = String(clock.hour).padStart(2, '0')
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-xs" data-testid="demo-clock">
      <span className="text-muted">Test clock</span>
      <b className="font-mono" data-testid="clock-now">
        {clock.weekday.slice(0, 3)} {clock.date} {hour}:00
      </b>
      {[1, 4].map((hours) => (
        <button
          key={hours}
          type="button"
          className="btn btn-secondary btn-sm"
          disabled={busy}
          onClick={() => onAdvance(hours)}
          data-testid={'clock-plus-' + hours}
        >
          +{hours} h
        </button>
      ))}
      <button
        type="button"
        className="btn btn-secondary btn-sm"
        disabled={busy}
        onClick={onNextDayTen}
        data-testid="clock-next-day"
      >
        next day 10:00
      </button>
    </div>
  )
}
